import PropTypes from 'prop-types';
import servicesStrings from 'modules/services/strings';

import DropdownMenu from 'modules/common/components/DropdownMenu/DropdownMenu';
import { statusList } from 'modules/common/enums';
import MultiSelectionDropdownFitler from 'modules/common/components/MultiSelectionDropdownFilter';
import { status } from 'constants/general';
import {
  Wrapper,
  SearchBarWrapper,
  SearchBar,
  SearchBarIcon,
  DropdownWrapper,
  DropdownsWrapper,
} from './ServicesFilter.style';

const ServicesFilter = ({
  handleSearchBarInputChange,
  handleDropdownInputChange,
  handleMultiSelectDropDownInputChange,
  servicesListApiCallBody,
  masterServicesList,
  specialitiesList,
}) => {
  const tempStatusList = [{ value: 'all', name: 'All Statuses' }, ...statusList];
  return (
    <Wrapper>
      <DropdownsWrapper>
        <DropdownWrapper>
          <DropdownMenu
            dropdownMenuItemsList={tempStatusList}
            dropdownMenuSelectedObj={tempStatusList.find(
              type => type.value === servicesListApiCallBody.statuskey,
            )}
            handleDropdownMenuChange={obj => {
              handleDropdownInputChange(obj.key, 'statuskey');
            }}
            placeholder={servicesStrings.servicesFilter.statusDropdownPlaceholder}
            objectMapper={{ key: 'value', name: 'name' }}
          />
        </DropdownWrapper>
        {masterServicesList?.details?.results?.length > 0 && (
          <DropdownWrapper>
            <MultiSelectionDropdownFitler
              dropdownMenuItemsList={masterServicesList?.details?.results}
              dropdownMenuSelectedArr={
                servicesListApiCallBody.masterservicekeys?.length > 0
                  ? servicesListApiCallBody.masterservicekeys
                  : []
              }
              dropdownMenuPlaceholder={
                servicesStrings.servicesFilter.masterServiceDropdownPlaceholder
              }
              handleDropdownMenuChange={value =>
                handleMultiSelectDropDownInputChange('masterservicekeys', value)
              }
              objectMapper={{ key: 'masterServiceKey', name: 'masterServiceNameEn' }}
              showLoader={masterServicesList.status === status.FETCHING}
            />
          </DropdownWrapper>
        )}
        <DropdownWrapper>
          <MultiSelectionDropdownFitler
            dropdownMenuItemsList={specialitiesList?.details}
            dropdownMenuSelectedArr={
              servicesListApiCallBody.specialitykeys?.length > 0
                ? servicesListApiCallBody.specialitykeys
                : []
            }
            dropdownMenuPlaceholder={servicesStrings.servicesFilter.specialityDropdownPlaceholder}
            handleDropdownMenuChange={value =>
              handleMultiSelectDropDownInputChange('specialitykeys', value)
            }
            objectMapper={{ key: 'SpecialityKey', name: 'SpecialityNameEnglish' }}
            showLoader={specialitiesList.status === status.FETCHING}
          />
        </DropdownWrapper>
      </DropdownsWrapper>
      <SearchBarWrapper>
        <SearchBarIcon />
        <SearchBar
          id="search-bar-input"
          placeholder={servicesStrings.servicesFilter.searchBarPlaceholder}
          onChange={handleSearchBarInputChange}
          value={servicesListApiCallBody.searchterm}
        />
      </SearchBarWrapper>
    </Wrapper>
  );
};
ServicesFilter.propTypes = {
  handleSearchBarInputChange: PropTypes.func.isRequired,
  handleDropdownInputChange: PropTypes.func.isRequired,
  handleMultiSelectDropDownInputChange: PropTypes.func.isRequired,
  servicesListApiCallBody: PropTypes.shape({
    statuskey: PropTypes.string,
    masterservicekeys: PropTypes.arrayOf(PropTypes.string),
    specialitykeys: PropTypes.arrayOf(PropTypes.string),
    searchterm: PropTypes.string,
  }).isRequired,
  masterServicesList: PropTypes.shape({
    details: PropTypes.shape({
      results: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    status: PropTypes.string,
  }).isRequired,
  specialitiesList: PropTypes.shape({
    details: PropTypes.shape({}),
    status: PropTypes.string,
  }).isRequired,
};

export default ServicesFilter;
